<template>
  <div class="box-content page--inner">

    <div class="box-title">
      <h2>TIMELINE</h2>
    </div>
    <div class="box-timeline">
      <template v-for="(item, index) in timeline">
        <div
          class="timeline-item"
          :class="{ 'join-company': item.joinCompany, 'leave-company': item.leaveCompany, 'project': item.project}"
          :date-is="item.date"
          :key="index">
          <h1>{{ item.title }}</h1>
          <p v-if="item.description" v-html="item.description"></p>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      timeline: [
        {
          date: "2022年04月01日",
          title: "株式会社フルート",
          joinCompany: true
        },
        {
          date: "2022年02月28日",
          title: "コルデコ株式会社退社",
          joinCompany: false
        },
        {
          date: "2021年04月01日",
          title: "コルデコ株式会社入社",
          joinCompany: true
        },
        {
          date: "2021年03月31日",
          title: "RELATIONS株式会社退社",
          joinCompany: false
        },
        {
          date: "2019年04月15日",
          title: "RELATIONS株式会社入社",
          joinCompany: true
        },
        {
          date: "2019年02月28日",
          title: "株式会社オハコ退社",
          leaveCompany: true
        },
        {
          date: "2018年10月01日 〜 2018年12月28日",
          title: "LINE CAREER",
          description: `
            10月から年末までLINE CAREERの開発チームに参加させていただきました。<br />
            業務内容 : 不具合対応・改善・調査<br />
            フレームワーク : Nuxt
          `,
          project: true
        },
        {
          date: "2018年08月22日 〜 2018年09月30日",
          title: "LINE TICKET",
          description: `
            8月末から10月までLINE TICKETの開発チームに参加させていただきました。<br />
            業務内容 : 不具合対応・新機能開発<br />
            フレームワーク : Vue.js (SSR), vuex
          `,
          project: true
        },
        {
          date: "2018年02月05日 〜 2018年08月20日",
          title: "MACASO",
          description: `
            株式会社エキサイトワンのMacasoというFXアプリを開発いたしました。<br />
            業務内容 : <ul>
              <li>フロントエンド開発</li>
              <li>基礎・データ構築開発</li>
              <li>WebSocket開発</li>
              <li>PC・スマホ版開発</li>
              <li>Highchartsでチャート開発</li>
            </ul>
            開発言語 : HTML5, CSS3, SASS, PHP<br />
            フレームワーク : Vue.js, Vuex, SockJs, Highcharts<br />
            開発環境 : Laravel, Docker<br />
            プロジェクト要員 : 7 名 (社内のみ)
          `,
          project: true
        },
        {
          date: "2018年01月15日",
          title: "株式会社オハコ入社",
          joinCompany: true,
          description: `
            従業員数 : 27 名(2017 年 9 月現在)<br />
            雇用形態 : 正社員<br />
            事業内容 :<ul>
              <li>新規プロジェクト開発 ( 代表製品 : macaso )</li>
              <li>LINE プロジェクトの開発チームに参加 (LINE Ticket, Career)</li>
              <li>自社プロジェクト開発</li>
              <li>テンプレート開発</li>
            </ul>
            言語開発 : HTML5、CSS3、Javascript, Vue.js、Vuex、Nuxt、React、Redux、Highcharts<br />
            開発環境 : Webpack、Node、Laravel、Docker、Gulp
          `
        },
        {
          date: "2018年01月14日",
          title: "株式会社オルトプラス退社",
          leaveCompany: true
        },
        {
          date: "2017年04月",
          title: "株式会社ハッテ",
          joinCompany: true,
          description: `
            副業サイドワークで株式会社ハッテの開発チームに参加させていただきました。<br />
            従業員数 : 2 名<br />
            雇用形態 :フリーランス<br />
            事業内容 : <ul>
              <li> ホームページ制作、キャンペーンサイト開発</li>
              <li>プロジェクト : OREO、RITZ、Clorets 等のキャンペーンサイト開発</li>
            </ul>
            言語開発 : HTML5、CSS3、Gulp、EJS、Javascript、jQuery
          `
        },
        {
          date: "2016年02月 〜 2018年01月",
          title: "Idolmaster SideM",
          description: `9ヶ月ぐらい別のプロジェクトに参加させていただきました。<br />担当しておりましたタスクが終わり次第、「Idolmaster SideM」に戻りました。`
        },
        {
          date: "2015年05月 〜 2016年02月",
          title: "ガンダムエリアウォーズ",
          description: `
            Webviewを使っているIOS / Androidのガンダムのゲーム<br />
            業務内容 : <ul>
              <li>フロントエンド開発、改善</li>
              <li>Javascriptでアニメーション開発</li>
              <li>jQueryのプラグイン開発</li>
              <li>パフォーマンスの評価・最適化</li>
              <li>デバック</li>
            </ul>
            開発環境 : HTML5, CSS3, PHP, Jquery, Javascript, Git, Photoshop<br />
            プロジェクト要員 : 〜20 名
          `,
          project: true
        },
        {
          date: "2014年06月01日 〜 2016年05月",
          title: "Idolmaster SideM",
          description: `
          2014年7月にリリースされたモバゲーのソーシャルゲーム (IOS / Android / 携帯)<br />
            業務内容 : <ul>
              <li>新規開発 : フロントエンド</li>
              <li>jQueryのプラグイン開発</li>
              <li>CreateJsでアニメーション開発</li>
              <li>イベントのフロントエント開発・改善・設定</li>
              <li>デバック</li>
              <li>機能の提案の仕様作成</li>
            </ul>
            開発環境 : HTML5, CSS3, PHP, Jquery, Javascript, CreateJs, Git<br />
            プロジェクト要員 : 〜20 名
          `,
          project: true
        },
        {
          date: "2014年05月15日",
          title: "株式会社オルトプラス入社",
          joinCompany: true,
          description: `
            従業員数 : 連結:204 名 (2015 年 9 月現在)<br />
            雇用形態 : 正社員<br />
            事業内容 : <ul>
              <li>モバゲーのソーシャルゲームのフロントエンド開発(IOS/Android/携帯)(代表製品: Idolmaster SideM)</li>
              <li>Android/IOS のゲーム:フロントエンド開発の最適化(代表製品:ガンダムエリアウォーズ)</li>
              <li>新規アプリサビースのフロントエンド開発</li>
              <li>ホームページ開発 (例 : オルトプラス採用サイト)</li>
            </ul>
            言語開発 : HTML5、CSS3、Javascript、jQuery、CreateJs、Angular v.1、PHP、SQL、GIT、ChromeApp
          `
        },
        {
          date: "2014年04月",
          title: "エデンズフィール株式会社退社",
          leaveCompany: true
        },
        {
          date: "2013年01月",
          title: "エデンズフィール株式会社入社",
          joinCompany: true,
          description: `
            従業員数 : 3 名<br />
            雇用形態 : 契約社員・正社員<br />
            事業内容 : ホームページ制作<br />
            言語開発 : HTML5、CSS3、Javascript、jQuery、PHP、SQL、CakePHP
          `
        },
        {
          date: "2012年10月03日",
          title: "来日"
        },
        {
          date: "2012年09月30日",
          title: "NPO「TechnofuturTIC」退社",
          leaveCompany: true
        },
        {
          date: "2012年06月30日",
          title: "「Cours Communaux Commerciaux de Charleroi」夜間学校 言語学部 日本語学科 卒業"
        },
        {
          date: "2011年09月05日",
          title: "「Cours Communaux Commerciaux de Charleroi」夜間学校 言語学部 日本語学科 入学"
        },
        {
          date: "2011年07月01日 〜 2012年09月30日",
          title: "Menteos",
          description: `
            ベルギーの学校のための研修プログラム、e ラーニ ングプログラム、レポート作成のためのアプリケーション<br />
            業務内容 : <ul>
              <li>サーバーサイド開発</li>
              <li>フロントエンド開発</li>
              <li>Elggというフラームワークのプラグインを作成</li>
              <li>顧客からのQ&A対応</li>
            </ul>
            開発環境 : HTML5, CSS3, PHP, Jquery, Javascript, Photoshop, Elgg Framework<br />
            プロジェクト要員 : 3 名
          `,
          project: true
        },
        {
          date: "2011年07月01日",
          title: "NPO「TechnofuturTIC」入社",
          joinCompany: true,
          description: `
            従業員数 : 20 名以上<br />
            雇用形態 :契約社員<br />
            事業内容 : <ul>
              <li>教育の国立プロジェクト開発(代表製品: MenteOS)</li>
              <li>Elgg という PHP フラムワークで SNS サイトを作成・開発</li>
              <li>学校の先生と連絡を取り、教育のツールを作成・開発</li>
              <li>サーバーサイド開発</li>
              <li>フロントエンド開発</li>
              <li>勉強会開催</li>
            </ul>
            言語開発 : PHP、SQL、Elgg、Javascript、jQuery、HTML、CSS
          `
        },
        {
          date: "2011年06月15日",
          title: "「HEPH Condorcet」専門学校 マルチメディア学部 ウェブ開発学科 卒業",
          graduate: true
        },
        {
          date: "2008年09月14日",
          title: "「HEPH Condorcet」専門学校 マルチメディア学部 ウェブ開発学科 入学"
        },
        {
          date: "2003年",
          title: "14歳に初めてのウェブサイト",
          description: "HTML, CSS, PHPでアニメのウェブサイトを開発しました"
        },
        {
          date: "1989年09月05日",
          title: "生年月日"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
// ----------------  THE BASICS

@import url('https://fonts.googleapis.com/css?family=Oswald|Roboto:400,700');

$border-color: rgba(black, .3);

.box-timeline {
  padding: 50px 70px
}
.timeline-item {
	padding: 3em 2em 2em;
	position: relative;
	color: rgba(black, .7);
	border-left: 2px solid $border-color;

  &::before {
		content: attr(date-is);
		position: absolute;
		left: 2em;
		font-weight: bold;
		top: 1em;
		display: block;
		font-family: 'Roboto', sans-serif;
		font-weight: 700;
		font-size: .785rem;
	}

	&::after {
		width: 12px;
		height: 12px;
		display: block;
		top: 1em;
		position: absolute;
		left: -7px;
		border-radius: 10px;
		content: '';
		border: 2px solid $border-color;
		background: white;
	}

  h1 {
    font-size: 18px;
    font-weight: 700;
  }

  &.join-company {
    h1 {
      color: #008e00;
    }
  }
  &.leave-company {
    h1 {
      color: #333;
      font-weight: 400;
    }
  }
  &.project {
    h1 {
      color: #2376b2;
    }
  }

	&:last-child {
		border-image: linear-gradient(
			to bottom,
			$border-color 60%,
			rgba($border-color, 0)) 1 100%
		;
	}
  ul {
    margin: 12px 0 24px 24px;
  }
}

@media screen and (max-width: $max-width-tablet) {
  .box-timeline {
    padding: 20px;
  }
  .timeline-item {
    h1 {
      font-size: 16px;
    }
    p, li, ul {
      font-size: 13px;
    }
  }
}

@media screen and (max-width: $max-width-mobile) {
  .box-timeline {
    padding: 10px;
  }
  .timeline-item {
    h1 {
      font-size: 16px;
    }
    p, li, ul {
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/about/Timeline.vue